/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ token: NonNullable<unknown> }} Sitesettings_Hint_Name1Inputs */

const vi_sitesettings_hint_name1 = /** @type {(inputs: Sitesettings_Hint_Name1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phải có ${i?.token} — chỗ đặt tên danh mục / sản phẩm.`)
};

/**

* @param {Sitesettings_Hint_Name1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_hint_name1 = /** @type {((inputs: Sitesettings_Hint_Name1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Hint_Name1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_hint_name1(inputs)
});
export { sitesettings_hint_name1 as "siteSettings_hint_name" }